import React from 'react';
import './footer.scss';
import emblem1S from '../../assets/emblem1S.png';
import emblem2S from '../../assets/emblem2S.png';

const Footer = ({handleModal}) => {

    return (
        <footer className='footer'>
            <div className='footer-container'>
                <ul>
                    <li onClick={() => handleModal({open: true, content: 'Triassic Park no se hace responsable de tu seguridad y la de tus bienes durante la visita al parque. Usted participa voluntaria y únicamente bajo su propia responsabilidad en esta visita. Por ello, exime de cualquier responsabilidad a la organización, colaboradores, patrocinadores y otros visitantes y conviene en no denunciarles en caso de cualquier pérdida de extremidades, muerte, daño físico o material.'})}>Descargo de Responsabilidad</li>
                    <li onClick={() => handleModal({open: true, content: 'Al entrar al parque se da por hecho que ha leído y está de acuerdo con el Descargo de Responsabilidad.'})}>Aviso Legal</li>
                    <li onClick={() => handleModal({open: true, content: 'error'})}>Política de Privacidad</li>
                    <li onClick={() => handleModal({open: true, content: 'Estamos a favor de las galletas. De todas, de todos los sabores y colores.'})}>Política de cookies</li>
                </ul>
                <ul>
                    <li onClick={() => handleModal({open: true, content: 'about'})}>Sobre nosotros</li>
                    <li><a href='https://linktr.ee/jacinmaeron' target="blank">Contacto</a></li>
                    <li onClick={() => handleModal({open: true, content: 'Ponte en contacto con nosotros para resolver cualquier duda.'})}>Preguntas frecuentes</li>
                    <li onClick={() => handleModal({open: true, content: '¿Eres genetista y quieres trabajar con nosotros? Estaríamos encantados de contar contigo. ¡Mandanos tu currículum!'})}>Trabaja con nosotros</li>
                    <li onClick={() => handleModal({open: true, content: 'downloads'})}>Descargas</li>
                </ul>
                <ul className='ul-emblems'>
                    <li><img className="logo" src={emblem1S} alt="triassic park logo" height={130} /></li>
                    <li><img className="logo" src={emblem2S} alt="triassic park logo" height={130} /></li>
                </ul>
            </div>
            <p>2023 TRIASSICPARK</p>
        </footer>
    )
}

export default Footer;